var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1080 1080" },
    },
    [
      _c("g", { attrs: { id: "kreis" } }, [
        _c("path", {
          attrs: {
            d: "m538.83,31.67c68.61,0,135.16,13.43,197.79,39.93,60.51,25.59,114.86,62.24,161.53,108.91,46.68,46.68,83.32,101.02,108.91,161.53,26.49,62.64,39.93,129.18,39.93,197.79s-13.43,135.16-39.93,197.79c-25.59,60.51-62.24,114.86-108.91,161.53-46.68,46.68-101.02,83.32-161.53,108.91-62.64,26.49-129.18,39.93-197.79,39.93s-135.16-13.43-197.79-39.93c-60.51-25.59-114.86-62.24-161.53-108.91-46.68-46.68-83.32-101.02-108.91-161.53-26.49-62.64-39.93-129.18-39.93-197.79s13.43-135.16,39.93-197.79c25.59-60.51,62.24-114.86,108.91-161.53,46.68-46.68,101.02-83.32,161.53-108.91,62.64-26.49,129.18-39.93,197.79-39.93m0-22C246.03,9.67,8.67,247.03,8.67,539.83s237.36,530.17,530.17,530.17,530.17-237.36,530.17-530.17S831.64,9.67,538.83,9.67h0Z",
          },
        }),
      ]),
      _vm._v(" "),
      _c("g", { attrs: { id: "Linie_28pt" } }, [
        _c("g", [
          _c("path", {
            attrs: {
              d: "m540,884.25c-46.47,0-91.55-9.1-134-27.06-40.99-17.34-77.81-42.16-109.42-73.77-31.61-31.61-56.43-68.43-73.77-109.42-17.95-42.45-27.06-87.53-27.06-134s9.1-91.55,27.06-134c17.34-40.99,42.16-77.81,73.77-109.42,31.61-31.61,68.43-56.43,109.42-73.77,42.45-17.95,87.53-27.06,134-27.06s91.55,9.1,134,27.06c40.99,17.34,77.81,42.16,109.42,73.77,31.61,31.61,56.43,68.43,73.77,109.42,17.95,42.45,27.06,87.53,27.06,134s-9.1,91.55-27.06,134c-17.34,40.99-42.16,77.81-73.77,109.42-31.61,31.61-68.43,56.43-109.42,73.77-42.45,17.95-87.53,27.06-134,27.06Zm0-666.5c-177.69,0-322.25,144.56-322.25,322.25s144.56,322.25,322.25,322.25,322.25-144.56,322.25-322.25-144.56-322.25-322.25-322.25Z",
            },
          }),
          _vm._v(" "),
          _c("g", [
            _c("circle", { attrs: { cx: "540", cy: "237.26", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "540", cy: "842.28", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "236.55", cy: "541.31", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "841.58", cy: "541.31", r: "10.17" } }),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("circle", { attrs: { cx: "540.93", cy: "237.49", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "540.93", cy: "842.51", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "237.49", cy: "541.54", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "842.51", cy: "541.54", r: "10.17" } }),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("circle", { attrs: { cx: "683.89", cy: "274.19", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "395.92", cy: "806.29", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "272.3", cy: "397.17", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "804.4", cy: "685.14", r: "10.17" } }),
          ]),
          _vm._v(" "),
          _c("g", [
            _c("circle", { attrs: { cx: "802.5", cy: "391.05", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "276.56", cy: "690.11", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "388.19", cy: "277.56", r: "10.17" } }),
            _vm._v(" "),
            _c("circle", { attrs: { cx: "687.26", cy: "803.5", r: "10.17" } }),
          ]),
          _vm._v(" "),
          _c("circle", { attrs: { x: "540", cy: "540", r: "10.17" } }),
          _vm._v(" "),
          _c("rect", {
            attrs: { x: "529.92", y: "271.92", width: "22", height: "268.08" },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "403.9",
              y: "609.42",
              width: "182.54",
              height: "22",
              transform: "translate(-288.48 746.96) rotate(-60.58)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }